/**
 * Constants used throughout the application
 */

/**
 * Page break token used to separate pages in text processing
 * Can be changed to any other token as needed
 */
export const PAGE_BREAK_TOKEN = '<STRONA>';

/**
 * Language hint sent to /api/normalize.
 *
 * The route gates its Polish rules — keep diacritics, do not change word forms,
 * do not invent dialog dashes — behind a hint matching /^pl\b/i. No caller ever
 * passed one, so those rules had never run in production against a Polish app
 * used by Polish readers.
 *
 * Note the code: 'pl', not the 'pol' that Tesseract takes. They are different
 * standards, ISO 639-1 against 639-2, and 'pol' does not match that test — so
 * copying the Tesseract value here would look right and silently do nothing.
 */
export const DEFAULT_NORMALIZE_LANG_HINT = 'pl';

